export const isSessionTimeoutError = (body) => {
  if (body?.error === "Session validation failed") {
    return true;
  }

  if (body?.fault?.faultstring) {
    const faultString = body.fault.faultstring;
    if (faultString.includes("Execution of ServiceCallout SC-Logout failed") && 
        faultString.includes("ResponseCode 401")) {
      return true;
    }
  }

  return false;
};
